import EN_ITEM_MESSAGE_CODE from "./en-items";
import EN_MESSAGES_MESSAGE_CODE from "./en-messages";

const EN_MESSAGE_CODE = {
    ...EN_ITEM_MESSAGE_CODE,
    ...EN_MESSAGES_MESSAGE_CODE,
};

export default EN_MESSAGE_CODE;
